import { createRouter, createWebHashHistory } from 'vue-router'

// 适配 nginx 子路径部署(如 /new),从 import.meta.env.BASE_URL 读取
const routerBase = import.meta.env.BASE_URL || '/'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout, getParentLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { NO_RESET_WHITE_LIST } from '@/constants'
const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'Root',
    meta: {
      // hidden: true,
      // noTagsView: true
    }
  },
  {
    path: '/dashboard',
    component: Layout,
    name: 'Dashboard',
    meta: {
      title: '控制台',
      icon: 'ep:home-filled',
      alwaysShow: true
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Dashboard/Dashboard.vue'),
        name: 'DashboardIndex',
        meta: {
          title: '首页',
          icon: 'ep:home-filled'
        }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/user',
    component: Layout,
    name: 'User',
    meta: {
      hidden: true,
      noTagsView: true
    },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/User/Profile.vue'),
        name: 'Profile',
        meta: {
          title: '修改密码',
          noTagsView: true
        }
      }
    ]
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'RedirectWrap',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: '404',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: Layout,
    name: 'Dashboard',
    meta: {
      title: '控制台',
      icon: 'ep:home-filled',
      alwaysShow: true
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Dashboard/Dashboard.vue'),
        name: 'DashboardIndex',
        meta: {
          title: '首页',
          icon: 'ep:home-filled'
        }
      },
      {
        path: 'workbench',
        component: () => import('@/views/Dashboard/WorkBench.vue'),
        name: 'WorkBench',
        meta: {
          title: '工作台',
          icon: 'ep:home-filled'
        }
      }
    ]
  },
  {
    path: '/baseData',
    component: Layout,
    redirect: '/baseData/goodGenre',
    name: 'BaseData',
    meta: {
      title: '基础数据',
      icon: 'ep:goods',
      alwaysShow: true
    },
    children: [
      {
        path: 'goodGenre',
        component: () => import('@/views/BaseData/GoodsGenre.vue'),
        name: 'GoodGenre',
        meta: {
          title: '商品类别',
          icon: 'ep:goods'
        }
      },
      {
        path: 'uploadImg',
        component: () => import('@/views/BaseData/UploadImg.vue'),
        name: 'UploadImg',
        meta: {
          title: '上传图片',
          icon: 'ep:goods'
        }
      }
    ]
  },
  {
    path: '/supplier',
    component: Layout,
    redirect: '/supplier/list',
    name: 'SupplierManage',
    meta: {
      title: '供应商',
      icon: 'ep:goods',
      alwaysShow: true
    },
    children:[
      {
        path: 'list',
        component: () => import('@/views/Supplier/Supplier.vue'),
        name: 'SupplierList',
        meta: {
          title: '供货商',
          icon: 'ep:office-building'
        }
      },
      {
        path: 'pricerule',
        component: () => import('@/views/Supplier/PriceRule.vue'),
        name: 'PriceRule',
        meta: {
          title: '价格规则',
          icon: 'ep:office-building'
        }
      },
    ]
  },
  {
    path: '/storehouse',
    component: Layout,
    redirect: '/storehouse/list',
    name: 'StorehouseManage',
    meta: {
      title: '仓储管理',
      icon: 'ep:house',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Storehouse/StorehouseList.vue'),
        name: 'StorehouseList',
        meta: {
          title: '仓库信息',
          icon: 'ep:office-building'
        }
      },
      {
        path: 'stockEntry',
        component: () => import('@/views/Storehouse/StockEntry.vue'),
        name: 'StockEntry',
        meta: {
          title: '入库单',
          icon: 'ep:document'
        }
      },
      {
        path: 'stockOut',
        component: () => import('@/views/Storehouse/StockOut.vue'),
        name: 'StockOut',
        meta: {
          title: '出库单',
          icon: 'ep:document-copy'
        }
      },
      {
        path: 'allocation',
        component: () => import('@/views/Storehouse/Allocation.vue'),
        name: 'Allocation',
        meta: {
          title: '配货单',
          icon: 'ep:document-checked'
        }
      }
    ]
  },
  {
    path:'/procure',
    component: Layout,
    redirect:'/procure/purchase',
    name:'Procure',
    meta:{
      title: '采购',
      icon: 'ep:goods',
      alwaysShow: true
    },
    children:[
      {
        path: 'restock',
        component: () => import('@/views/Procure/Restock.vue'),
        name: 'Restock',
        meta: {
          title: '补货单',
          icon: 'ep:shopping-bag'
        }
      },
      {
        path: 'purchase',
        component: () => import('@/views/Procure/Purchase.vue'),
        name: 'Purchase',
        meta: {
          title: '采购单',
          icon: 'ep:shopping-cart'
        }
      },
      {
        path: 'purReturn',
        component: () => import('@/views/Procure/PurReturn.vue'),
        name: 'PurReturn',
        meta: {
          title: '采购退货单',
          icon: 'ep:refresh-left'
        }
      }
    ]
  },
  {
    path: '/goods',
    component: Layout,
    redirect: '/goods/list',
    name: 'GoodsManage',
    meta: {
      title: '商品',
      icon: 'ep:goods',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Goods/GoodsList.vue'),
        name: 'GoodsList',
        meta: {
          title: '商品管理',
          icon: 'ep:goods'
        }
      },
      {
        path: 'data',
        component: () => import('@/views/Goods/GoodsData.vue'),
        name: 'GoodsData',
        meta: {
          title: '商品数据',
          icon: 'ep:data-analysis'
        }
      },
      {
        path: 'category',
        component: () => import('@/views/Goods/GoodsCategory.vue'),
        name: 'GoodsCategory',
        meta: {
          title: '分类管理',
          icon: 'ep:menu'
        }
      },
      {
        path: 'brand',
        component: () => import('@/views/Goods/Brand.vue'),
        name: 'GoodsBrand',
        meta: {
          title: '品牌管理',
          icon: 'ep:medal'
        }
      },
      {
        path: 'customer',
        component: () => import('@/views/Goods/Customer.vue'),
        name: 'Customer',
        meta: {
          title: '客户管理',
          icon: 'ep:user'
        }
      },
      {
        path: 'wholesale',
        component: () => import('@/views/Goods/WholesaleOrder.vue'),
        name: 'WholesaleOrder',
        meta: {
          title: '客户下单',
          icon: 'ep:shopping-cart'
        }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/list',
    name: 'OrderManage',
    meta: {
      title: '订单',
      icon: 'ep:document',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Order/OrderList.vue'),
        name: 'OrderList',
        meta: {
          title: '订单列表',
          icon: 'ep:document'
        }
      },
      {
        path: 'after-sale',
        component: () => import('@/views/Order/AfterSale.vue'),
        name: 'AfterSale',
        meta: {
          title: '售后退款',
          icon: 'ep:refresh-left'
        }
      }
    ]
  },
  {
    path: '/activity',
    component: Layout,
    redirect: '/activity/class',
    name: 'ActivityManage',
    meta: {
      title: '活动',
      icon: 'ep:calendar',
      alwaysShow: true
    },
    children: [
      {
        path: 'class',
        component: () => import('@/views/Activity/ClassActivity.vue'),
        name: 'ClassActivity',
        meta: {
          title: '案例演示',
          icon: 'ep:tickets'
        }
      },
      {
        path: 'theme',
        component: () => import('@/views/Activity/ThemeActivity.vue'),
        name: 'ThemeActivity',
        meta: {
          title: '活动主题',
          icon: 'ep:star'
        }
      },
      {
        path: 'contact',
        component: () => import('@/views/Activity/EnterpriseContact.vue'),
        name: 'EnterpriseContact',
        meta: {
          title: '企业联系人',
          icon: 'ep:user'
        }
      },
      {
        path: 'purchase',
        component: () => import('@/views/Activity/EgpInfo.vue'),
        name: 'GroupPurchase',
        meta: {
          title: '团购意向',
          icon: 'ep:shopping-cart'
        }
      },
      {
        path: 'selection',
        component: () => import('@/views/Activity/EnterpriseChoice.vue'),
        name: 'EnterpriseChoice',
        meta: {
          title: '企业选款',
          icon: 'ep:tickets'
        }
      },
      {
        path: 'selection-group',
        component: () => import('@/views/Activity/ChoiceGroup.vue'),
        name: 'ChoiceGroup',
        meta: {
          title: '选款分组',
          icon: 'ep:tickets'
        }
      }
    ]
  },
  {
    path: '/marketing',
    component: Layout,
    redirect: '/marketing/coupon',
    name: 'MarketingManage',
    meta: {
      title: '营销',
      icon: 'ep:present',
      alwaysShow: true
    },
    children: [
      {
        path: 'activity',
        component: () => import('@/views/Marketing/Activity.vue'),
        name: 'Activity',
        meta: {
          title: '专区活动',
          icon: 'ep:star-filled'
        }
      },
      {
        path: 'coupon',
        component: () => import('@/views/Marketing/Coupon.vue'),
        name: 'Coupon',
        meta: {
          title: '优惠券',
          icon: 'ep:ticket'
        }
      },
      {
        path: 'voucher',
        component: () => import('@/views/Marketing/Voucher.vue'),
        name: 'Voucher',
        meta: {
          title: '提货券',
          icon: 'ep:tickets'
        }
      },
      {
        path: 'footprint',
        component: () => import('@/views/Marketing/Footprint.vue'),
        name: 'Footprint',
        meta: {
          title: '足迹气泡',
          icon: 'ep:location'
        }
      },
      {
        path:'questionnaire',
        component:() => import('@/views/Marketing/Questionnaire.vue'),
        name:'Questionnaire',
        meta:{
          title:'报码问卷',
          icon:'ep:tickets'
        }
      }
    ]
  },
  {
    path: '/decoration',
    component: Layout,
    redirect: '/decoration/index',
    name: 'DecorationManage',
    meta: {
      title: '装修',
      icon: 'ep:cellphone',
      alwaysShow: true
    },
    children: [
      {
        path: 'ad',
        component: () => import('@/views/Content/Ad.vue'),
        name: 'AdManage',
        meta: {
          title: '广告',
          icon: 'ep:picture'
        }
      },
      {
        path: 'index',
        component: () => import('@/views/Decoration/IndexDecoration.vue'),
        name: 'IndexDecoration',
        meta: {
          title: '首页',
          icon: 'ep:home-filled'
        }
      },
      {
        path: 'user-center',
        component: () => import('@/views/Decoration/UserCenter.vue'),
        name: 'UserCenter',
        meta: {
          title: '我的',
          icon: 'ep:user'
        }
      },
      {
        path: 'category',
        component: () => import('@/views/Decoration/CategoryDecoration.vue'),
        name: 'CategoryDecoration',
        meta: {
          title: '分类',
          icon: 'ep:menu'
        }
      },
      {
        path: 'bottom-nav',
        component: () => import('@/views/Decoration/BottomNav.vue'),
        name: 'BottomNav',
        meta: {
          title: '底部导航',
          icon: 'ep:menu'
        }
      }
    ]
  },
  {
    path: '/wechat',
    component: Layout,
    redirect: '/wechat/oa',
    name: 'WechatManage',
    meta: {
      title: '微信',
      icon: 'ep:chat-dot-round',
      alwaysShow: true
    },
    children: [
      {
        path: 'oa',
        component: () => import('@/views/Wechat/OaSetting.vue'),
        name: 'OaSetting',
        meta: {
          title: '公众号设置',
          icon: 'ep:chat-dot-round'
        }
      },
      {
        path: 'oa-menu',
        component: () => import('@/views/Wechat/OaMenu.vue'),
        name: 'OaMenu',
        meta: {
          title: '公众号菜单',
          icon: 'ep:menu'
        }
      },
      {
        path: 'mnp',
        component: () => import('@/views/Wechat/MnpSetting.vue'),
        name: 'MnpSetting',
        meta: {
          title: '小程序设置',
          icon: 'ep:cellphone'
        }
      },
      {
        path: 'open-platform',
        component: () => import('@/views/Wechat/OpenPlatform.vue'),
        name: 'OpenPlatform',
        meta: {
          title: '开放平台',
          icon: 'ep:connection'
        }
      },
      {
        path: 'reply',
        component: () => import('@/views/Wechat/Reply.vue'),
        name: 'WechatReply',
        meta: {
          title: '回复管理',
          icon: 'ep:chat-line-round'
        }
      }
    ]
  },
  {
    path: '/dataAnalysis',
    component: Layout,
    redirect: '/finance/index',
    name: 'DataAnalysis',
    meta: {
      title: '数据分析',
      icon: 'ep:money',
      alwaysShow: true
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/Finance/Finance.vue'),
        name: 'FinanceIndex',
        meta: {
          title: '财务概况',
          icon: 'ep:money'
        }
      },
      {
        path: 'goods-report',
        component: () => import('@/views/Finance/GoodsReport.vue'),
        name: 'FinanceGoodsReport',
        meta: {
          title: '商品报表',
          icon: 'ep:data-analysis'
        }
      },
      {
        path: 'sales-report',
        component: () => import('@/views/Finance/SalesReport.vue'),
        name: 'FinanceSalesReport',
        meta: {
          title: '销售报表',
          icon: 'ep:trend-charts'
        }
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/goods',
    name: 'StatisticsManage',
    meta: {
      title: '数据',
      icon: 'ep:data-analysis',
      alwaysShow: true
    },
    children: [
      {
        path: 'member',
        component: () => import('@/views/Statistics/Member.vue'),
        name: 'StatisticsMember',
        meta: {
          title: '用户',
          icon: 'ep:user'
        }
      },
      {
        path: 'goods',
        component: () => import('@/views/Statistics/Goods.vue'),
        name: 'StatisticsGoods',
        meta: {
          title: '商品',
          icon: 'ep:goods'
        }
      },
      {
        path: 'deal',
        component: () => import('@/views/Statistics/Deal.vue'),
        name: 'StatisticsDeal',
        meta: {
          title: '交易',
          icon: 'ep:document'
        }
      },
      {
        path: 'visit',
        component: () => import('@/views/Statistics/Visit.vue'),
        name: 'StatisticsVisit',
        meta: {
          title: '访问',
          icon: 'ep:view'
        }
      }
    ]
  },
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/website',
    name: 'SettingManage',
    meta: {
      title: '设置',
      icon: 'ep:setting',
      alwaysShow: true
    },
    children: [
      {
        path: 'website',
        component: () => import('@/views/Setting/Website.vue'),
        name: 'Website',
        meta: {
          title: '网站设置',
          icon: 'ep:monitor'
        }
      },
      {
        path: 'pay',
        component: () => import('@/views/Setting/Pay.vue'),
        name: 'PayConfig',
        meta: {
          title: '支付设置',
          icon: 'ep:money'
        }
      },
      {
        path: 'sms',
        component: () => import('@/views/Setting/SmsManage.vue'),
        name: 'Sms',
        meta: {
          title: '短信管理',
          icon: 'ep:message'
        }
      },
      {
        path: 'upload',
        component: () => import('@/views/Setting/StorageConfig.vue'),
        name: 'Upload',
        meta: {
          title: '上传设置',
          icon: 'ep:upload'
        }
      },
      {
        path: 'notice',
        component: () => import('@/views/Setting/Notice.vue'),
        name: 'Notice',
        meta: {
          title: '通知设置',
          icon: 'ep:bell'
        }
      },
      {
        path: 'trading',
        component: () => import('@/views/Setting/Trading.vue'),
        name: 'Trading',
        meta: {
          title: '交易设置',
          icon: 'ep:document'
        }
      },
      {
        path: 'register',
        component: () => import('@/views/Setting/Register.vue'),
        name: 'Register',
        meta: {
          title: '注册设置',
          icon: 'ep:user'
        }
      },
      {
        path: 'hot-search',
        component: () => import('@/views/Setting/HotSearch.vue'),
        name: 'HotSearch',
        meta: {
          title: '热门搜索',
          icon: 'ep:search'
        }
      },
      {
        path: 'express',
        component: () => import('@/views/Setting/Express.vue'),
        name: 'Express',
        meta: {
          title: '配送管理',
          icon: 'ep:van'
        }
      },
      {
        path: 'printer',
        component: () => import('@/views/Setting/Printer.vue'),
        name: 'Printer',
        meta: {
          title: '小票打印',
          icon: 'ep:printer'
        }
      },
      {
        path: 'service',
        component: () => import('@/views/Setting/Service.vue'),
        name: 'Service',
        meta: {
          title: '客服设置',
          icon: 'ep:service'
        }
      },
      {
        path: 'policy',
        component: () => import('@/views/Setting/Policy.vue'),
        name: 'Policy',
        meta: {
          title: '政策协议',
          icon: 'ep:document'
        }
      }
    ]
  },
  {
    path: '/member',
    component: Layout,
    redirect: '/member/user',
    name: 'MemberManage',
    meta: {
      title: '用户',
      icon: 'ep:user',
      alwaysShow: true
    },
    children: [
      {
        path: 'user',
        component: () => import('@/views/Member/User.vue'),
        name: 'MemberUser',
        meta: {
          title: '用户管理',
          icon: 'ep:user'
        }
      },
      {
        path: 'group',
        component: () => import('@/views/Member/Group.vue'),
        name: 'MemberGroup',
        meta: {
          title: '用户分组',
          icon: 'ep:tickets'
        }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/admin',
    name: 'SystemManage',
    meta: {
      title: '系统',
      icon: 'ep:tools',
      alwaysShow: true,
      roles: ['admin']
    },
    children: [
      {
        path: 'admin',
        component: () => import('@/views/System/AdminList.vue'),
        name: 'AdminList',
        meta: {
          title: '管理员',
          icon: 'ep:user',
          roles: ['admin']
        }
      },
      {
        path: 'role',
        component: () => import('@/views/System/RoleList.vue'),
        name: 'RoleList',
        meta: {
          title: '角色',
          icon: 'ep:avatar',
          roles: ['admin']
        }
      },
      {
        path: 'menu',
        component: () => import('@/views/System/MenuList.vue'),
        name: 'MenuList',
        meta: {
          title: '菜单权限',
          icon: 'ep:menu',
          roles: ['admin']
        }
      },
      {
        path: 'crontab',
        component: () => import('@/views/System/Crontab.vue'),
        name: 'Crontab',
        meta: {
          title: '计划任务',
          icon: 'ep:timer'
        }
      },
      {
        path: 'upgrade',
        component: () => import('@/views/System/Upgrade.vue'),
        name: 'Upgrade',
        meta: {
          title: '系统更新',
          icon: 'ep:upload'
        }
      },
      {
        path: 'cache',
        component: () => import('@/views/System/Cache.vue'),
        name: 'Cache',
        meta: {
          title: '系统缓存',
          icon: 'ep:folder'
        }
      },
      {
        path: 'log',
        component: () => import('@/views/System/Log.vue'),
        name: 'Log',
        meta: {
          title: '系统日志',
          icon: 'ep:document'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(routerBase),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
